<template>

    <div class="card">
      <div class="card-body">
        <h4 class="card-title">{{$t('Companies')}}</h4>
        <p class="card-description">
          <!--For displaying tabular data. <code>&lt;b-table&gt;</code> supports pagination, filtering, sorting, custom rendering, events, and asynchronous data.-->
        </p>
        <b-container fluid>
          <!-- User Interface controls -->
          <b-row>
            <b-col lg="4" class="my-1">
              <b-form-group
                class="mb-0"
              >
                <b-input-group size="sm">
                  <b-form-input
                    v-model="filter"
                    type="search"
                    id="filterInput"
                    :placeholder="$t('Type to Search')"
                  ></b-form-input>
                  <b-input-group-append>
                    <b-button :disabled="!filter" @click="filter = ''">{{$t('Clear')}}</b-button>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>
            <!--<b-col>-->
              <!--<b-btn v-show="['System Admin', 'Administrator'].includes($store.state.user.data.role)" style="float:right;color:white;margin-bottom: 20px" variant="light" v-b-modal.modal-create-category>{{$t('Create Company')}}</b-btn>-->
            <!--</b-col>-->

          </b-row>
          <!-- Main table element -->

          <b-table
            responsive
            show-empty
            hover
            small
            ref="table"
            :items="$store.state.categories"
            :fields="fields"
            :current-page="currentPage"
            :per-page="perPage"
            :filter="filter"
            :filterIncludedFields="filterOn"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :sort-direction="sortDirection"
            @filtered="onFiltered"
          >
            <template v-slot:empty="scope">
              <div class="text-center my-2"> {{$t('There are no records to show')}} </div>
            </template>
            <template v-slot:cell(id)="row">
              <b-link :append="true" class="nav-link" :to="{path: `/company/${row.item.id}`}">{{ row.item.name }} </b-link>
            </template>

            <!--<template v-slot:cell(manager)="row">-->
              <!--<b-link v-if="row.item.managerId" :append="true" class="nav-link" :to="'/users/'+row.item.managerId">{{ row.item.managerName }} </b-link>-->
              <!--<b-link v-else @click="getCompanyUsers(row.item.name)" v-b-modal.modal-assign-manager class="text-secondary">{{$t('Assign Manager')}}</b-link>-->
            <!--</template>-->

            <template v-slot:cell(managers)="row">
              <b-list-group flush v-if="row.item.managers">
                <b-list-group-item style="border-bottom: 0;background: unset;padding-top: 5px;padding-bottom: 5px;">
                  <div style="line-height: 26px;" v-bind:key="manager.managerId" v-for="manager in row.item.managers">
                    <b-link :append="true" style="display: inline;padding-top: 5px;padding-bottom: 5px;" class="nav-link" :to="'/users/'+manager.managerId">{{ manager.managerName }} </b-link>
                    <b-link class="text-danger float-right" @click="removeManager(row.item.id, manager.managerId, manager.managerName)">Remove</b-link>
                  </div>
                </b-list-group-item>
                <b-link v-if="row.item.managers.length < 3" @click="getCompanyManagerUsers(row.item.id)" v-b-modal.modal-assign-manager class="text-secondary">{{$t('Add Manager')}}</b-link>

              </b-list-group>
              <b-link v-else @click="getCompanyManagerUsers(row.item.id)" v-b-modal.modal-assign-manager class="text-secondary">{{$t('Assign Manager')}}</b-link>
            </template>
            <template v-slot:cell(status)="row">
              <label :class="row.item.status === 'Active' ? ' badge badge-success' : 'badge badge-danger'" style="text-align: center;">{{ row.item.status }}</label>
            </template>

            <template v-slot:cell(actions)="row" >
              <b-button variant="outline-primary" size="sm" @click="editCategory(row.item)" class="mr-1">
                {{$t('Edit')}}
              </b-button>
              <!--<b-button v-show="['System Admin', 'Administrator'].includes($store.state.user.data.role)" variant="outline-danger" size="sm" @click="deleteCategory(row.item, row.index)">-->
                <!--{{$t('Delete')}}-->
              <!--</b-button>-->
            </template>
          </b-table>

          <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            class="my-5"
          ></b-pagination>

        </b-container>
        <!--<b-modal-->
          <!--id="modal-create-category"-->
          <!--ref="modal"-->
          <!--:title="$t('Create Company')"-->
          <!--@show="resetModal"-->
          <!--@hidden="resetModal"-->
          <!--@ok="createCategory"-->
          <!--okVariant="light"-->
          <!--ok-title-html="<span style='color:white;'>Submit</span>"-->
          <!--header-bg-variant="light"-->
          <!--header-text-variant="white"-->
        <!--&gt;-->
          <!--<form ref="form">-->
            <!--<div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">-->
              <!--<b-spinner-->
                <!--variant="secondary"-->
              <!--&gt;</b-spinner>-->
            <!--</div>-->
            <!--<b-form-group-->
              <!--:label="$t('Name of Company')"-->
              <!--label-for="name-input"-->
            <!--&gt;-->
              <!--<b-form-input-->
                <!--id="group-name"-->
                <!--v-model="newCategory.name"-->
                <!--:state="$v.newCategory.name.$dirty ? !$v.newCategory.name.$error : null"-->
              <!--&gt;</b-form-input>-->
              <!--<b-form-invalid-feedback id="input-5-live-feedback">-->
                <!--{{$t('Name is a required field.')}}-->
              <!--</b-form-invalid-feedback>-->
            <!--</b-form-group>-->
            <!--<b-form-group-->
              <!--style="width: 50%;float: right"-->
              <!--:label="$t('VAT')"-->
              <!--label-for="vat-input"-->
            <!--&gt;-->
              <!--<b-form-input-->
                <!--type="text"-->
                <!--v-model="newCategory.vat"-->
              <!--&gt;</b-form-input>-->
            <!--</b-form-group>-->
            <!--<b-form-group-->
              <!--style="width: 50%;float: left;padding-right: 10px"-->
              <!--:label="$t('Contact Number')"-->
              <!--label-for="tel-input"-->
            <!--&gt;-->
              <!--<b-form-input-->
                <!--type="tel"-->
                <!--v-model="newCategory.contactNumber"-->
              <!--&gt;</b-form-input>-->
            <!--</b-form-group>-->
            <!--<b-form-group-->
              <!--:label="$t('Contact Email')"-->
              <!--label-for="tel-input"-->
            <!--&gt;-->
              <!--<b-form-input-->
                <!--id="name-input4"-->
                <!--type="tel"-->
                <!--v-model="newCategory.contactEmail"-->
              <!--&gt;</b-form-input>-->
            <!--</b-form-group>-->
            <!--<b-form-group-->
              <!--:label="$t('Address')"-->
              <!--label-for="address-input"-->
            <!--&gt;-->
              <!--<b-form-textarea-->
                <!--rows="4"-->
                <!--no-resize-->
                <!--id="name-input3"-->
                <!--type="text"-->
                <!--v-model="newCategory.address"-->
              <!--&gt;</b-form-textarea>-->
            <!--</b-form-group>-->
            <!--<b-form-group-->
              <!--:label="$t('Notes')"-->
              <!--label-for="notes-input"-->
            <!--&gt;-->
              <!--<b-form-textarea-->
                <!--rows="4"-->
                <!--no-resize-->
                <!--id="notes-input"-->
                <!--type="text"-->
                <!--v-model="newCategory.notes"-->
              <!--&gt;</b-form-textarea>-->
            <!--</b-form-group>-->
          <!--</form>-->
        <!--</b-modal>-->
        <b-modal
        id="modal-edit-category"
        ref="modal"
        :title="$t('Edit Company')"
        @show="resetCategoryModal"
        @hidden="resetCategoryModal"
        @ok="saveCategory"
        okVariant="light"
        ok-title-html="<span style='color:white;'>Save</span>"
        header-bg-variant="light"
        header-text-variant="white"
      >
        <form ref="form">
          <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
            <b-spinner
              variant="secondary"
            ></b-spinner>
          </div>
          <b-form-group
            label="Name"
            label-for="name-input"
          >
            <b-form-input
              id="name-input9"
              type="text"
              v-model="categoryData.name"
              :state="$v.categoryData.name.$dirty ? !$v.categoryData.name.$error : null"
            ></b-form-input>
            <b-form-invalid-feedback id="input-5-live-feedback">
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group v-show="['System Admin', 'Administrator'].includes($store.state.user.data.role)"  id="input-group-4" label="Manager:" label-for="input-4">
            <multiselect v-model="categoryData.managers" :groupSelect="false" :optionHeight="10" :showLabels="false" deselectLabel="" selectLabel="" :options="companyManagerUsers" :multiple="true" :close-on-select="false" :searchable="false" :clear-on-select="false" :taggable="false" :preserve-search="false" :placeholder="$t('Select Manager')" label="managerName" track-by="managerId" :preselect-first="false">
              <!--<template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>-->
            </multiselect>
            <!--<b-form-select-->
              <!--id="input-4"-->
              <!--size="sm"-->
              <!--v-model="categoryData.manager"-->
              <!--:options="companyUsers"-->
              <!--:state="$v.categoryData.manager.$dirty ? !$v.categoryData.manager.$error : null"-->
            <!--&gt;</b-form-select>-->
            <b-form-invalid-feedback id="input-7-live-feedback">
              This is a required field.
            </b-form-invalid-feedback>
          </b-form-group>
          <b-form-group
            :label="$t('Contact Number')"
            style="width: 50%;float: left;padding-right: 10px"
          >
            <b-form-input
              type="tel"
              v-model="categoryData.contactNumber"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            style="width: 50%;float: right"
            :label="$t('VAT')"
          >
            <b-form-input
              type="text"
              v-model="categoryData.vat"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            :label="$t('Contact Email')"
            label-for="name-input"
          >
            <b-form-input
              id="group-name"
              v-model="categoryData.contactEmail"
            ></b-form-input>
          </b-form-group>
          <b-form-group
            :label="$t('Address')"
          >
            <b-form-textarea
              rows="4"
              no-resize
              type="text"
              v-model="categoryData.address"
            ></b-form-textarea>
          </b-form-group>
          <b-form-group
            :label="$t('Notes')"
          >
            <b-form-textarea
              rows="4"
              no-resize
              type="text"
              v-model="categoryData.notes"
            ></b-form-textarea>
          </b-form-group>
        </form>
      </b-modal>
        <b-modal
          id="modal-assign-manager"
          ref="modal"
          :title="$t('Assign User as Group Manager')"
          @show="resetAssignUserModal"
          @hidden="resetAssignUserModal"
          @ok="assignManager"
          okVariant="light"
          ok-title-html="<span style='color:white;'>Submit</span>"
          header-bg-variant="light"
          header-text-variant="white"
        >
          <form ref="form">
            <div v-if="loading" class="d-flex justify-content-center mb-3 form-spinner" style="padding-top: 40px;">
              <b-spinner
                variant="secondary"
              ></b-spinner>
            </div>
            <b-form-group @keydown.native.enter="assignManager" id="input-group-4" :label="$t('Select User:')" label-for="input-4">
              <b-form-select
                id="input-4"
                size="sm"
                v-model="assignManagerData.userId"
                value-field="managerId"
                text-field="managerName"
                :options="companyManagerUsers"
                :state="$v.assignManagerData.userId.$dirty ? !$v.assignManagerData.userId.$error : null"
              ></b-form-select>
              <b-form-invalid-feedback id="input-7-live-feedback">
                {{$t('This is a required field.')}}
              </b-form-invalid-feedback>
            </b-form-group>
          </form>
        </b-modal>
      </div>
    </div>

</template>

<script>
import { required } from 'vuelidate/lib/validators'
export default {
  data () {
    return {
      loading: false,
      categoryData: {
        name: null,
        managers: []
      },
      statuses: [{text: this.$t('Active'), value: 'Active'}, {text: this.$t('Inactive'), value: 'Inactive'}, {text: this.$t('Expired'), value: 'Expired'}],
      companyUsers: [],
      companyManagerUsers: [],
      newCategory: {
        numberOfGroups: 0,
        name: ''
      },
      assignManagerData: {
        userId: ''
      },
      totalRows: 1,
      currentPage: 1,
      perPage: 15,
      pageOptions: [5, 10, 15],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },
  validations: {
    newCategory: {
      name: {
        required
      }
    },
    assignManagerData: {
      userId: {
        required
      }
    },
    categoryData: {
      name: {
        required
      }
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    },
    fields () {
      var aFields = []
      aFields.push({ key: 'id', label: this.$t('Company Name'), sortable: true, sortDirection: 'desc', class: 'text-left' })
      if (['System Admin', 'Administrator'].includes(this.$store.state.user.data.role)) {
        aFields.push({ key: 'managers', label: this.$t('Managers'), sortable: true, class: 'text-center' })
      }
      aFields.push({ key: 'contactNumber', label: this.$t('Contact Number'), sortable: false, class: 'text-center' })
      aFields.push({ key: 'createdAt', label: this.$t('Created At'), sortable: true, class: 'text-center' })
      aFields.push({ key: 'actions', label: this.$t('Actions'), class: 'text-center' })

      return aFields
    }
  },
  mounted () {
    // Set the initial number of items
    this.totalRows = this.$store.state.categories.length
    this.$store.dispatch('fetchCategories')
    // this.mapUsers()
    // console.log(this.$store.state.users)
  },
  methods: {
    createCategory (e) {
      e.preventDefault()

      this.$v.newCategory.$touch()
      if (this.$v.newCategory.$anyError) {
        return
      }
      this.loading = true
      let self = this
      const createCategory = this.$firebase.functions().httpsCallable('createCategory')
      this.newCategory.companyId = this.$store.state.user.data.companyId
      createCategory(this.newCategory).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$swal({
            title: self.$t('Company Created!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            self.$store.dispatch('fetchCategories')
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    removeManager (categoryId, managerId, managerName) {
      var self = this
      this.$bvModal.msgBoxConfirm(self.$t('removeManagerFromCategoryWarning'),
        {
          title: self.$t('Are you sure?'),
          okVariant: 'danger',
          okTitle: self.$t('Confirm'),
          centered: true
        })
        .then(value => {
          if (value) {
            self.loading = true
            const deleteCat = this.$firebase.functions().httpsCallable('removeManager')
            deleteCat({categoryId: categoryId, managerId: managerId, managerName: managerName, companyId: self.$store.state.user.data.companyId}).then(function (result) {
              // success or error handling
              if (result.data.errorInfo) {
                self.$swal({
                  title: self.$t('There was an error!'),
                  text: result.data.errorInfo.message,
                  type: 'error',
                  timer: 0,
                  showConfirmButton: true
                })
              } else {
                self.$store.dispatch('fetchCategories')
                self.$swal({
                  title: self.$t('Manager Removed!'),
                  type: 'success',
                  timer: 2000,
                  showConfirmButton: false
                }).then(function (result) {
                  self.$refs.modal.hide()
                })
              }
              self.loading = false
            })
          }
        })
    },
    getCompanyUsers (catId = null) {
      var self = this
      if (catId != null) {
        this.assignManagerData.categoryId = catId
      }
      this.$firebase.firestore().collection('users').where('companyId', '==', self.$store.state.user.data.companyId).get().then(function (users) {
        self.companyUsers = [{text: self.$t('Select User'), value: ''}]
        users.forEach(function (user) {
          var userData = user.data()
          var name = userData.firstName + ' ' + userData.lastName
          self.companyUsers.push({value: user.id, text: name})
        })
      })
    },
    getCompanyManagerUsers (categoryId = null) {
      // setting selected category
      if (categoryId) {
        this.assignManagerData.categoryId = categoryId
      }
      var self = this
      this.$firebase.firestore().collection('users').where('companyId', '==', self.$store.state.user.data.companyId).where('role', '==', 'Manager').get().then(function (users) {
        self.companyManagerUsers = []
        users.forEach(function (user) {
          console.log(user.data())
          var userData = user.data()
          var name = userData.firstName + ' ' + userData.lastName
          self.companyManagerUsers.push({managerId: user.id, managerName: name})
        })
      })
    },
    assignManager (e) {
      e.preventDefault()
      var self = this
      this.$v.assignManagerData.$touch()
      if (this.$v.assignManagerData.$anyError) {
        return
      }
      this.loading = true

      var user = this.companyManagerUsers.find(m => m.managerId === this.assignManagerData.userId)
      this.assignManagerData.userName = user.managerName
      this.assignManagerData.companyId = this.$store.state.user.data.companyId
      const createUser = this.$firebase.functions().httpsCallable('assignManagerToGroup')
      createUser(this.assignManagerData).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$store.dispatch('fetchCategories')
          self.$swal({
            title: self.$t('Manager Added!'),
            type: 'success',
            timer: 2000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.table.refresh()
            self.$refs.modal.hide()
          })
        }
        self.loading = false
      })
    },
    resetModal () {
      this.newCategory.name = ''
      this.newCategory.contactEmail = ''
      this.newCategory.contactNumber = ''
      this.newCategory.vat = ''
      this.newCategory.notes = ''
      this.newCategory.address = ''
      this.loading = false
      this.$v.$reset()
    },
    resetAssignUserModal () {
      this.assignManagerData.userId = ''
      this.$v.$reset()
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    // async deleteCategory (item, index) {
    //   var self = this
    //   var groupInCategory = await this.$firebase.firestore().collectionGroup('groups').where('category', '==', item.name).limit(1).get().then(data => {
    //     return data.size
    //   })
    //
    //   if (groupInCategory) {
    //     self.$swal({
    //       title: self.$t('Cannot Delete Category!'),
    //       text: self.$t('It seems that the category has groups. You have to delete all groups first'),
    //       type: 'error',
    //       timer: 0,
    //       showConfirmButton: true
    //     })
    //     return
    //   }
    //
    //   this.$bvModal.msgBoxConfirm(self.$t('You are about to delete this Category. This action cannot be undone.'),
    //     {
    //       title: self.$t('Are you sure?'),
    //       okVariant: 'danger',
    //       okTitle: self.$t('Confirm'),
    //       centered: true
    //     })
    //     .then(value => {
    //       if (value) {
    //         self.loading = true
    //         const deleteCat = this.$firebase.functions().httpsCallable('deleteCategory')
    //         deleteCat({id: item.name, companyId: this.$store.state.user.data.companyId}).then(function (result) {
    //           // success or error handling
    //           if (result.data.errorInfo) {
    //             self.$swal({
    //               title: self.$t('There was an error!'),
    //               text: result.data.errorInfo.message,
    //               type: 'error',
    //               timer: 0,
    //               showConfirmButton: true
    //             })
    //           } else {
    //             self.$store.dispatch('fetchCategories')
    //             self.$swal({
    //               title: self.$t('Category Removed!'),
    //               type: 'success',
    //               timer: 2000,
    //               showConfirmButton: false
    //             }).then(function (result) {
    //               self.$refs.modal.hide()
    //             })
    //           }
    //           self.loading = false
    //         })
    //       }
    //     })
    // },
    saveCategory: function (e) {
      e.preventDefault()
      var self = this
      this.$v.categoryData.$touch()
      if (this.$v.categoryData.$anyError) {
        return
      }
      this.loading = true
      // this.categoryData.managerName = this.companyUsers.find(u => u.value === self.categoryData.manager).text
      console.log('this.categoryData', this.categoryData)
      const updateCat = this.$firebase.functions().httpsCallable('updateCategory')
      updateCat(this.categoryData).then(function (result) {
        // success or error handling
        if (result.data.errorInfo) {
          self.$swal({
            title: self.$t('There was an error!'),
            text: result.data.errorInfo.message,
            type: 'error',
            timer: 0,
            showConfirmButton: true
          })
        } else {
          self.$store.dispatch('fetchCategories')
          self.$swal({
            title: self.$t('Category Updated!'),
            type: 'success',
            timer: 1000,
            showConfirmButton: false
          }).then(function (result) {
            self.$refs.modal.hide()
            self.$refs.table.refresh()
          })
        }
        self.loading = false
      })
    },
    resetCategoryModal () {
      this.loading = false
      this.$v.$reset()
    },
    editCategory (item) {
      this.getCompanyManagerUsers(item.id)
      var cg = this.$store.state.categories.find(c => c.id === item.id)
      this.categoryData.id = cg.id
      this.categoryData.name = cg.name
      this.categoryData.contactNumber = cg.contactNumber
      this.categoryData.contactEmail = cg.contactEmail
      this.categoryData.companyId = this.$store.state.user.data.companyId
      this.categoryData.managers = cg.managers
      this.categoryData.notes = cg.notes
      this.categoryData.vat = cg.vat
      this.categoryData.address = cg.address
      this.$bvModal.show('modal-edit-category')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Categories.vue